import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromSale from '../sale/sale.reducer'
import { SaleCheckoutShowComponent } from './checkout/show.component'
import { PaymentModule } from './payment/payment.module'
import { SaleItemModule } from './sale-item/sale-item.module'
import { SaleRoutingModule } from './sale-routing.module'
import { SaleEffects } from './sale.effects'
import { SaleSerializer } from './sale.serializer'
import { SaleService } from './sale.service'
import { SaleShowComponent } from './show/show.component'
import { SaleCallbackComponent } from './callback/show.component'
import { PendingSaleGuard } from './pending-sale.guard'
import { RoleModule } from '../role/role.module'
import { MemberModule } from '../member/member.module'
import { SaleFailedModalComponent } from './sale-failed-modal/sale-failed-modal.component'
import { SendConfirmationModalComponent } from './callback/send-confirmation-modal/send-confirmation-modal.component'
import { CreateStoredPayMethodModalComponent } from './checkout/create-stored-paymethod-modal/create-stored-paymethod-modal.component'

@NgModule({
  imports: [
    CommonModule,
    SaleRoutingModule,
    MemberModule,
    SharedModule,
    StoreModule.forFeature(fromSale.FEATURE_NAME, fromSale.saleReducer),
    EffectsModule.forFeature([SaleEffects]),
    PaymentModule,
    SaleItemModule,
    RoleModule
  ],
  declarations: [
    SendConfirmationModalComponent,
    SaleCheckoutShowComponent,
    SaleShowComponent,
    SaleCallbackComponent,
    SaleFailedModalComponent,
    CreateStoredPayMethodModalComponent
  ],
  providers: [
    SaleService,
    {
      provide: SaleSerializer,
      useClass: SaleSerializer
    },
    PendingSaleGuard
  ]
})
export class SaleModule {}
